<script>
    import Card from '../card/Card.svelte';

    const randomReviews = []
    let testimonials = []

    const reviews=[{text:"I slashed my rates in half after signing up. Best financial move I've made for my car!",name:"Connor M."},{text:"The savings were unbelievable! I'm now paying so much less for my auto insurance.",name:"Ava P."},{text:"I never knew how much I could save on auto insurance until I signed up. This has been a game changer!",name:"Elijah R."},{text:"The signup process was a breeze, and the savings are real. I'm recommending this to everyone!",name:"Sophia N."},{text:"If you think you can't save on car insurance, think again. I saved a bundle. Give them a call!",name:"Amir J."},{text:"Excellent coverage for less money. This is the smartest way to insure your car!",name:"Grace K."},{text:"I'm so glad I switched my auto insurance. I have better coverage now and pay less!",name:"Lucas W."},{text:"Customer service that goes the extra mile and rates that keep your wallet happy!",name:"Mia Turner"},{text:"I had no hassles signing up, and now I'm enjoying the extra cash. A win-win for my auto needs!",name:"Oliver S."},{text:"My auto insurance worries are over. I've found the best rates and coverage right here.",name:"Chloe J."},{text:"This auto insurance deal was a no-brainer—top-notch coverage without the hefty price tag!",name:"Matteo H."},{text:"Switching to this insurance saved me money without compromising on service. Highly recommend!",name:"Emily B."},{text:"Signing up was as smooth as my ride. And the savings? Even smoother!",name:"Daniel G."},{text:"After signing up, I was amazed at the difference in my monthly expenses. More money for road trips now!",name:"Isabella M."},{text:"I was paying way too much before. Now, I've got great insurance and extra cash to boot!",name:"Henry T."},{text:"Finally, car insurance that makes sense and saves cents! You won't regret signing up.",name:"Zoe W."},{text:"Their claim process is quick and easy. Plus, the money I'm saving is incredible!",name:"Liam A."},{text:"Why overpay for car insurance? I'm so glad I discovered this and started saving!",name:"Emma T."},{text:"Cutting my insurance bill down was the best feeling. This service is top-notch!",name:"Noah L."},{text:"Wish I knew about this sooner. The savings on my auto insurance have been substantial!",name:"Layla H."}];
    function getRandomTestimonials(num){
        const shuffled=reviews.sort(() => 0.5 - Math.random());
        return shuffled.slice(0,num)
    }
    function displayTestimonials(){
        const randomTestimonials=getRandomTestimonials(3);
        randomTestimonials.forEach(testimonial=>{
            randomReviews.push(testimonial);
        })
        testimonials = randomReviews;
    }

    displayTestimonials();
</script>

<section class="cta-section">
    <p>ARE YOU CURRENTLY INSURED?</p>
    <div class="wrapper">
         <div class="buttons-wrapper">
            <a href="https://rt.policyquoteusa.com/click">
                <button class="button-1">YES</button>
            </a>
            <a href="https://rt.policyquoteusa.com/click">
                <button class="button-2">NO</button>
            </a>
        </div>
        <div class="divider"></div>
    </div>
    <p class="feedback">Recent Customer Feedback:</p>
    <div class="cards-wrapper" id="testimonials">
        {#each testimonials as {text, name}}
            <Card text={text} name={name} />
        {/each}
    </div>
</section>

<style>
    .cta-section {
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #000000;
        white-space: pre-wrap;
        word-wrap: break-word;
        text-align: center;
        font-weight: 700;
        font-size: 40px;
        line-height: 46px;
        margin-bottom: 30px;
        padding-top: 26px;
    }

    .wrapper {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 20px;
        max-width: 966px;
        width: 100%;
    }

    .buttons-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 58px;
        padding: 36px 0 20px;
        width: 100%;
    }

    .buttons-wrapper a {
        width: 100%;
        padding: 0 20px;
    }

    .buttons-wrapper button {
        background-color: #2f9ee9;
        color: #ffffff;
        border: none;
        border-radius: 12px;
        padding: 12px 20px;
        font-size: 32px;
        font-weight: 700;
        cursor: pointer;
        width: 100%;
    }

    .divider {
        width: 100%;
        margin: 0 100px;
        height: 10px;
        background-color: #efefef;
        margin-bottom: 10px;
    }

    .feedback {
        font-size: 30px;
        margin-bottom: 34px;
    }

    .cards-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 30px;
    }

    p {
        margin-block-start: 0;
        margin-block-end: 0;
    }

    @media (max-width: 700px) {
        .cta-section {
            font-size: 32px;
            line-height: 37px;
        }

        .buttons-wrapper {
            flex-direction: column;
            gap: 20px;
            width: 100%;
        }

        .buttons-wrapper a {
            width: 90%;
        }

        .buttons-wrapper button {
            width: 100%;
            height: 76px;
        }

        .feedback {
            font-size: 26px;
        }

        .cards-wrapper {
            padding: 0 20px;
        }
    }
</style>